
// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import PeopleIcon from '@mui/icons-material/People';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import ListAltIcon from '@mui/icons-material/ListAlt';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc    
};

const icoMenu = {
    PeopleIcon,
    PersonAddAlt1Icon,
    ListAltIcon
}

// ==============================|| CLIENTES MENU ITEMS ||============================== //

const cliente = {
    id: 'cliente',
    title: '',
    type: 'group',
    children: [
        {
            id: 'clienteMainMenu',
            title: 'Clientes',
            type: 'collapse',
            icon: icoMenu.PeopleIcon,
            children: [
                {
                    id: 'nuevo_cliente',
                    title: 'Nuevo Cliente',
                    type: 'item',
                    icon: icoMenu.PersonAddAlt1Icon,
                    url: '/user/new-clients/0'
                },
                {
                    id: 'lista_clientes',
                    title: 'Lista Clientes',
                    type: 'item',
                    icon: icoMenu.ListAltIcon,
                    url: '/user/list-clients-view'
                },                
            ]
        }
    ]
};

export default cliente;
